import { isArray } from "@amcharts/amcharts5/.internal/core/util/Type";
import { Button, Modal, Row, Table } from "antd";
import React, { useImperativeHandle, useState } from "react";
import { checkDataXML } from "./config";

const CheckDataXML = React.forwardRef((props, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState<any>([]);
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setData: setData,
  }));

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      open={isModalOpen}
      wrapClassName="modal-custom"
      centered
      onCancel={closeModal}
      closable={false}
      footer={null}
      title="Kiểm tra dữ liệu XML"
      width={1000}
    >
      {data.map((el) =>
        !isArray(el.value) ? (
          <ul style={{ fontWeight: "bold", marginLeft: 20 }}>
            <li>{el.value}</li>
          </ul>
        ) : (
          <Table
            dataSource={el.value}
            columns={checkDataXML}
            bordered
            pagination={false}
          />
        )
      )}
      <Row style={{ marginTop: "8px" }}>
        <Row justify={"end"} style={{ gap: "4px" }}>
          <Button type="primary" danger onClick={closeModal}>
            ĐÓNG
          </Button>
        </Row>
      </Row>
    </Modal>
  );
});

export default CheckDataXML;
